import forge from "node-forge";

// Use fetched or constant public key
const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzDx35411cLX7rj5yzIHF
Dwn5NgpPMLZHiIayxdZGc++boEj7zZrshXhwBeLP2k/9bAVlVnlvCYF7dbCy8VO2
eAeUEL7c5Rp2OXwbIOyOSAdiGrf6bxuE6Y+aA/n0x/c5OaqrsTfqMklmiq8yDPdG
rHQjdQLYebuiMEwP9RGQGUijnzIc9N4YcXXxAZ8ajrdyKmfZMp+WP5Qm3gghwyhp
ZfyfR2u/j53I4m4l0vjHrX5gtbxwLBkS/xrMSxlqudqUG7b5Eeqeaqv0bQt8Imyo
Ol0I/gnl2MMeB22BL0fV4W7TY2fT/w2U3Mz724vGuACIwhSydzaamD8odpLRlChT
pwIDAQAB
-----END PUBLIC KEY-----
`;

export function encryptPassword(password) {

    const env = process.env.REACT_APP_ENV

    if (env !== "production") return password

    const publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY);
    const encrypted = publicKey.encrypt(password, "RSA-OAEP");
    return forge.util.encode64(encrypted);
}
